import { createFileRoute } from "@tanstack/react-router";
import { PlansScreen, type PlansSearch } from "../screens/staff/PlansScreen.tsx";

/**
 * `/sysadmin/plans`: plans given by Adea (by signup link or domain) and promotion codes. Giving a plan and making a
 * code each ask for a click first; a signup link is shown once, for copying.
 */
export const Route = createFileRoute("/_staff/sysadmin/plans")({
  validateSearch: (search: Record<string, unknown>): PlansSearch =>
    search.tab === "codes" ? { tab: "codes" } : {},
  component: PlansScreen,
});
